// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var DomUtils = require("../../../shared/src/DomUtils.bs.js");
var DateUtils = require("../../../shared/src/DateUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var ReactWindow = require("react-window");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var WebTypes_View = require("../types/WebTypes_View.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var CommonTypes_Shift = require("../../../shared/src/types/CommonTypes_Shift.bs.js");
var WebComponents_ShiftCard = require("./WebComponents_ShiftCard.bs.js");
var BrowserComponents_FlexRow = require("../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserBindings_ReactWindow = require("../../../shared-browser/src/bindings/BrowserBindings_ReactWindow.bs.js");
var ReactVirtualizedAutoSizer = require("react-virtualized-auto-sizer").default;
var BrowserComponents_SectionHeader = require("../../../shared-browser/src/components/BrowserComponents_SectionHeader.bs.js");

function timestamp(param_0) {
  return {
          TAG: /* Timestamp */0,
          _0: param_0
        };
}

function shift(param_0) {
  return {
          TAG: /* Shift */1,
          _0: param_0
        };
}

function compare(param, param$1) {
  return Relude_Function.curry2((function (param) {
                var a = param[0];
                if (a.TAG === /* Timestamp */0) {
                  var b = param[1];
                  if (b.TAG === /* Timestamp */0) {
                    return Curry._3(Relude_String.compareWithConversion, (function (prim) {
                                  return prim.toISOString();
                                }), a._0, b._0);
                  } else {
                    return "less_than";
                  }
                }
                var match = param[1];
                if (match.TAG === /* Timestamp */0) {
                  return "greater_than";
                } else {
                  return Curry._2(CommonTypes_Shift.Id.compare, a._0.id, match._0.id);
                }
              }), param, param$1);
}

function eq(param, param$1) {
  return Relude_Function.curry2((function (param) {
                var a = param[0];
                if (a.TAG === /* Timestamp */0) {
                  var b = param[1];
                  if (b.TAG === /* Timestamp */0) {
                    return Relude_String.eq(a._0.toISOString(), b._0.toISOString());
                  } else {
                    return false;
                  }
                }
                var match = param[1];
                if (match.TAG === /* Timestamp */0) {
                  return false;
                } else {
                  return Curry._2(CommonTypes_Shift.Id.eq, a._0.id, match._0.id);
                }
              }), param, param$1);
}

var Ord = {
  compare: compare,
  eq: eq
};

var $$Map = Relude_Map.WithOrd({
      eq: eq,
      compare: compare
    });

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.justifyContent(BrowserStyle.center),
        tl: {
          hd: BrowserStyle.mobileMedia({
                hd: BrowserStyle.padding2(BrowserStyle.Spacing.small, BrowserStyle.Spacing.medium),
                tl: /* [] */0
              }),
          tl: {
            hd: BrowserStyle.paddingTop(BrowserStyle.Spacing.small),
            tl: {
              hd: BrowserStyle.paddingBottom(BrowserStyle.Spacing.small),
              tl: /* [] */0
            }
          }
        }
      }
    });

var Styles = {
  container: container
};

function WebComponents_DashboardShiftsList$ListItem$Shift(Props) {
  var currentDatetime = Props.currentDatetime;
  var currentShiftsListView = Props.currentShiftsListView;
  var isExpanded = Props.isExpanded;
  var onCancel = Props.onCancel;
  var onComment = Props.onComment;
  var onCopy = Props.onCopy;
  var onReviewWorker = Props.onReviewWorker;
  var setIsExpanded = Props.setIsExpanded;
  var shift = Props.shift;
  var setView = Props.setView;
  var timezone = Props.timezone;
  var workerShifts = shift.workerShifts;
  var shiftId = shift.id;
  var cancelledAt = shift.cancelledAt;
  var tmp;
  if (currentShiftsListView) {
    tmp = React.createElement(WebComponents_ShiftCard.Details.UpcomingShift.make, {
          currentDatetime: currentDatetime,
          shift: shift,
          onCancel: Curry._1(onCancel, shift),
          professionals: shift.workerShifts,
          setView: setView,
          key: Curry._1(CommonTypes_Shift.Id.toString, shiftId)
        });
  } else {
    var partial_arg = React.createElement(WebComponents_ShiftCard.Details.UpcomingShift.make, {
          currentDatetime: currentDatetime,
          shift: shift,
          onCancel: Curry._1(onCancel, shift),
          professionals: workerShifts,
          setView: setView,
          shiftStatus: /* Cancelled */1,
          key: Curry._1(CommonTypes_Shift.Id.toString, shiftId)
        });
    tmp = Relude_Option.fold(React.createElement(WebComponents_ShiftCard.Details.PastShift.make, {
              shift: shift,
              onComment: Curry._1(onComment, shift),
              onReviewWorker: onReviewWorker,
              professionalRatings: workerShifts,
              timezone: timezone,
              key: Curry._1(CommonTypes_Shift.Id.toString, shiftId)
            }), (function (param) {
            return Relude_Globals.$$const(partial_arg, param);
          }), cancelledAt);
  }
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: container,
              children: React.createElement(WebComponents_ShiftCard.Stateless.make, {
                    children: tmp,
                    isExpanded: Relude_Option.getOrElse(false, isExpanded),
                    onCopy: onCopy,
                    setIsExpanded: Curry._1(setIsExpanded, shiftId),
                    shift: shift,
                    shiftStatus: Relude_Option.isSome(cancelledAt) ? /* Cancelled */1 : /* Active */0,
                    timezone: timezone,
                    key: Curry._1(CommonTypes_Shift.Id.toString, shiftId)
                  }),
              key: Curry._1(CommonTypes_Shift.Id.toString, shiftId)
            });
}

var Shift = {
  Styles: Styles,
  make: WebComponents_DashboardShiftsList$ListItem$Shift
};

var container$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.justifyContent(BrowserStyle.center),
        tl: {
          hd: BrowserStyle.mobileMedia({
                hd: BrowserStyle.padding2(BrowserStyle.zero, BrowserStyle.Spacing.medium),
                tl: /* [] */0
              }),
          tl: /* [] */0
        }
      }
    });

var header = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* XLarge */5, undefined)({
          hd: BrowserStyle.flexBasis(BrowserStyle.pct(45.0)),
          tl: {
            hd: BrowserStyle.mobileMedia({
                  hd: BrowserStyle.flexBasis(BrowserStyle.pct(100.0)),
                  tl: /* [] */0
                }),
            tl: {
              hd: BrowserStyle.paddingTop(BrowserStyle.Spacing.large),
              tl: {
                hd: BrowserStyle.textAlign("left"),
                tl: /* [] */0
              }
            }
          }
        }));

var Styles$1 = {
  container: container$1,
  header: header
};

function WebComponents_DashboardShiftsList$ListItem$TimestampHeader(Props) {
  var timestamp = Props.timestamp;
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: container$1,
              children: React.createElement(BrowserComponents_SectionHeader.make, {
                    className: header,
                    children: DateUtils.formatDate(/* LongDate */10, /* Local */0)(timestamp)
                  })
            });
}

var TimestampHeader = {
  Styles: Styles$1,
  make: WebComponents_DashboardShiftsList$ListItem$TimestampHeader
};

function WebComponents_DashboardShiftsList$ListItem(Props) {
  var currentDatetime = Props.currentDatetime;
  var currentShiftsListView = Props.currentShiftsListView;
  var isExpanded = Props.isExpanded;
  var item = Props.item;
  var onCancel = Props.onCancel;
  var onComment = Props.onComment;
  var onCopy = Props.onCopy;
  var onReviewWorker = Props.onReviewWorker;
  var setIsExpanded = Props.setIsExpanded;
  var setView = Props.setView;
  var timezone = Props.timezone;
  if (item.TAG === /* Timestamp */0) {
    return React.createElement(WebComponents_DashboardShiftsList$ListItem$TimestampHeader, {
                timestamp: item._0
              });
  } else {
    return React.createElement(WebComponents_DashboardShiftsList$ListItem$Shift, {
                currentDatetime: currentDatetime,
                currentShiftsListView: currentShiftsListView,
                isExpanded: isExpanded,
                onCancel: onCancel,
                onComment: onComment,
                onCopy: onCopy,
                onReviewWorker: onReviewWorker,
                setIsExpanded: setIsExpanded,
                shift: item._0,
                setView: setView,
                timezone: timezone
              });
  }
}

var ListItem = {
  timestamp: timestamp,
  shift: shift,
  compare: compare,
  eq: eq,
  Ord: Ord,
  $$Map: $$Map,
  Shift: Shift,
  TimestampHeader: TimestampHeader,
  make: WebComponents_DashboardShiftsList$ListItem
};

function getDefaultShiftRowHeightForLayout(param) {
  if (param >= 2) {
    return 146;
  } else {
    return 210;
  }
}

function renderListItem(param) {
  var index = param.index;
  var match = param.data;
  var onReviewWorker = match.onReviewWorker;
  var onCopy = match.onCopy;
  var onComment = match.onComment;
  var onCancel = match.onCancel;
  var items = match.items;
  var expandedShifts = match.expandedShifts;
  var currentDatetime = match.currentDatetime;
  var match$1 = ReactIO.useDomRef(undefined);
  var rect = DomUtils.useDimensions(match$1[0]);
  var maybeHeight = Relude_Option.map((function (param) {
          return param.height;
        }), rect);
  var maybeItem = Relude_Array.at(index, items);
  var isExpanded = Curry._2(Relude_Option.flatMap, (function (param) {
          if (param.TAG === /* Timestamp */0) {
            return ;
          } else {
            return Curry._2(CommonTypes_Shift.Id.$$Map.get, param._0.id, expandedShifts);
          }
        }), maybeItem);
  var listItem = ReactIO.useMemo6((function (currentShiftsListView, isExpanded, maybeItem, setIsExpanded, setView, timezone) {
          return Relude_Option.fold(null, (function (item) {
                        return React.createElement(WebComponents_DashboardShiftsList$ListItem, {
                                    currentDatetime: currentDatetime,
                                    currentShiftsListView: currentShiftsListView,
                                    isExpanded: isExpanded,
                                    item: item,
                                    onCancel: onCancel,
                                    onComment: onComment,
                                    onCopy: onCopy,
                                    onReviewWorker: onReviewWorker,
                                    setIsExpanded: setIsExpanded,
                                    setView: setView,
                                    timezone: timezone
                                  });
                      }), maybeItem);
        }), [
        match.currentShiftsListView,
        isExpanded,
        maybeItem,
        match.setIsExpanded,
        match.setView,
        match.timezone
      ]);
  var partial_arg = Relude_IO.pure(undefined);
  var partial_arg$1 = function (param) {
    return Relude_Option.getOrElse(partial_arg, param);
  };
  var partial_arg$2 = Curry._1(Relude_Option.mapTuple2, match.updateHeight);
  var partial_arg$3 = function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg$1, param);
  };
  ReactIO.useEffect2(undefined, undefined, (function (param, param$1) {
          return Relude_Function.curry2(partial_arg$3, param, param$1);
        }), [
        Relude_Array.at(index, items),
        Relude_Option.map(Relude_Float.roundAsInt, maybeHeight)
      ]);
  return React.createElement("div", {
              style: param.style
            }, React.createElement("div", {
                  ref: match$1[1]
                }, listItem));
}

var listContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flexGrow(1.0),
      tl: /* [] */0
    });

var Styles$2 = {
  listContainer: listContainer
};

function WebComponents_DashboardShiftsList(Props) {
  var currentDatetime = Props.currentDatetime;
  var currentShiftsListView = Props.currentShiftsListView;
  var items = Props.items;
  var loadMoreShifts = Props.loadMoreShifts;
  var onCancel = Props.onCancel;
  var onComment = Props.onComment;
  var onCopy = Props.onCopy;
  var onReviewWorker = Props.onReviewWorker;
  var responsiveLayout = Props.responsiveLayout;
  var setView = Props.setView;
  var timezone = Props.timezone;
  var match = Curry._1(BrowserBindings_ReactWindow.List.Variable.useScrollRef, undefined);
  var virtualizedListRef = match[1];
  var virtualizedListDomRef = match[0];
  var match$1 = ReactIO.useMappableState($$Map.make);
  var setSizeMap = match$1[1];
  var sizeMap = match$1[0];
  var match$2 = ReactIO.useMappableState(CommonTypes_Shift.Id.$$Map.make);
  var setIsExpanded = match$2[1];
  var expandedShifts = match$2[0];
  var setIsExpanded$1 = ReactIO.useMemo0(function (param, shiftId, value) {
        return Curry._1(setIsExpanded, Curry._2(CommonTypes_Shift.Id.$$Map.set, shiftId, value));
      });
  var partial_arg = Curry._2(BrowserBindings_ReactWindow.List.Variable.resetAfterIndex, 0, true);
  ReactIO.useEffect1(undefined, undefined, (function (param) {
          return Relude_Globals.$great$great((function (param) {
                        return Relude_Globals.$$const(virtualizedListDomRef, param);
                      }), partial_arg, param);
        }), items);
  var updateHeight = ReactIO.useMemo2((function (virtualizedListDomRef, items, listItem, height) {
          return Relude_IO.flatMap((function (param) {
                        return Relude_Option.fold(Relude_IO.pure(undefined), (function (index) {
                                      return Curry._3(BrowserBindings_ReactWindow.List.Variable.resetAfterIndex, index, true, virtualizedListDomRef);
                                    }), Curry._3(Relude_Array.indexOf, {
                                        eq: eq
                                      }, listItem, items));
                      }), Curry._1(setSizeMap, Curry._2($$Map.set, listItem, height)));
        }), [
        virtualizedListDomRef,
        items
      ]);
  return React.createElement("div", {
              className: listContainer
            }, React.createElement(ReactVirtualizedAutoSizer, {
                  children: (function (param) {
                      return React.createElement(ReactWindow.VariableSizeList, Curry.app(BrowserBindings_ReactWindow.List.Variable.makeProps, [
                                      undefined,
                                      (function (index, param) {
                                          var param$1 = Relude_Array.at(index, param.items);
                                          if (param$1 !== undefined) {
                                            if (param$1.TAG === /* Timestamp */0) {
                                              return "timestamp-" + param$1._0.toISOString();
                                            } else {
                                              return "shift-" + Curry._1(CommonTypes_Shift.Id.toString, param$1._0.id);
                                            }
                                          } else {
                                            return "well-thats-no-good";
                                          }
                                        }),
                                      (function (param) {
                                          return Curry._2(loadMoreShifts, param.overscanStopIndex, items);
                                        }),
                                      renderListItem,
                                      undefined,
                                      undefined,
                                      getDefaultShiftRowHeightForLayout(responsiveLayout),
                                      param.height,
                                      undefined,
                                      Relude_Array.length(items),
                                      {
                                        currentDatetime: currentDatetime,
                                        currentShiftsListView: currentShiftsListView,
                                        expandedShifts: expandedShifts,
                                        items: items,
                                        onCancel: onCancel,
                                        onComment: onComment,
                                        onCopy: onCopy,
                                        onReviewWorker: onReviewWorker,
                                        setIsExpanded: setIsExpanded$1,
                                        setView: setView,
                                        timezone: timezone,
                                        updateHeight: updateHeight
                                      },
                                      (function (param) {
                                          return Relude_Globals.$great$great((function (__x) {
                                                        return Relude_Array.at(__x, items);
                                                      }), (function (param) {
                                                        return Relude_Option.fold(0, (function (listItem) {
                                                                      if (listItem.TAG === /* Timestamp */0) {
                                                                        return Relude_Option.getOrElse(52, Curry._2($$Map.get, listItem, sizeMap));
                                                                      } else {
                                                                        return Relude_Option.getOrElse(getDefaultShiftRowHeightForLayout(responsiveLayout), Curry._2($$Map.get, listItem, sizeMap));
                                                                      }
                                                                    }), param);
                                                      }), param);
                                        }),
                                      undefined,
                                      5,
                                      Caml_option.some(virtualizedListRef),
                                      undefined,
                                      undefined,
                                      param.width,
                                      Curry._1(WebTypes_View.BusinessDashboard.ShiftsList.toString, currentShiftsListView),
                                      undefined
                                    ]));
                    })
                }));
}

var timestampHeight = 52;

var make = WebComponents_DashboardShiftsList;

exports.ListItem = ListItem;
exports.timestampHeight = timestampHeight;
exports.getDefaultShiftRowHeightForLayout = getDefaultShiftRowHeightForLayout;
exports.renderListItem = renderListItem;
exports.Styles = Styles$2;
exports.make = make;
/* Map Not a pure module */
